import { RouteObject } from "react-router-dom";
import HomePage from "@/pages/home/page";
import ServiciosPage from "@/pages/servicios/page";
import VehiculosPage from "@/pages/vehiculos/page";
import SobreNosotrosPage from "@/pages/sobre-nosotros/page";
import ContactoPage from "@/pages/contacto/page";
import FaqPage from "@/pages/faq/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  { path: "/", element: <HomePage /> },
  { path: "/servicios", element: <ServiciosPage /> },
  { path: "/vehiculos", element: <VehiculosPage /> },
  { path: "/sobre-nosotros", element: <SobreNosotrosPage /> },
  { path: "/contacto", element: <ContactoPage /> },
  { path: "/faq", element: <FaqPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
